import { QueryMetadata } from "./query-metadata";

export class OrgQuery {
    Name: string;
    Metadata: QueryMetadata;
}
